export default {
  googleAnalyticsId: null,
  pasos: {
    paso1: {
      path: "/",
      component: "views/Referidos"
    },
    referidos: {
      path: "/:origen?",
      component: "views/Referidos"
    }
  }
};
